import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TrustBadgeProps {
  icon: string;
  title: string;
  description: string;
}

const TrustBadge = ({ icon, title, description }: TrustBadgeProps) => {
  return (
    <div className="flex flex-col items-center text-center space-y-3 p-6 bg-white rounded-xl shadow-soft hover:shadow-elevated transition-all duration-base">
      <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center">
        <Icon name={icon as any} size={32} variant="solid" className="text-white" />
      </div>
      <h3 className="font-headline font-bold text-text-primary text-lg">
        {title}
      </h3>
      <p className="text-text-secondary font-body text-sm leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default TrustBadge;